import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  ValidatorFn,
  AbstractControl,
  FormControl,
} from "@angular/forms";
import { CommonService } from "../common.service";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { CountryListsService } from "../country-lists.service";
import { TokenLogService } from "../_services/tokenLogService";
import { LogEntry } from "../_models/logEntry";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.css"],
})
export class RegistrationComponent implements OnInit {
  public addressChecking: FormControl = new FormControl(false);
  public registrationForm: FormGroup;
  public error: string;
  public values: any;
  public stateCityData = [];
  public stateCityDataForCheckAddress = [];
  public countryName: any;
  public stateName: any;
  public cityName: any;
  public checkAddressCountryName: any;
  public noMatchStateCity: any = 0;
  public selectedCity: any = 0;
  public noMatchStateCityForCheckAddress: any = 0;
  public companyNameError: any;
  public companyLegalNameError: any;
  public officeAddressError: any;
  public countryError: any;
  public cityError: any;
  public stateError: any;
  public contactFirstNameError: any;
  public contactCellError: any;
  public workPhNoError: any;
  public contactEmailAddressError: any;
  public zipCodeError: any;
  public checkAddressZipCodeError: any;
  public contactLastNameError: any;
  public defaultCityValue: any = "Select your City";
  public allCountries = [];
  public getFirstRegistrationFormVal: any;
  public defaultCheck1Error: any;
  public mask = {
    guide: true,
    mask: [
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
  };
  constructor(
    private _FB: FormBuilder,
    public authService: CommonService,
    private router: Router,
    private spinner: NgxSpinnerService,
    public countryService: CountryListsService,
    private readonly tokenLogService: TokenLogService
  ) {
    this.registrationForm = this._FB.group({
      companyName: ["", Validators.compose([Validators.required])],
      companyLegalName: ["", Validators.compose([Validators.required])],
      officeAddress: ["", Validators.compose([Validators.required])],
      city: ["", Validators.compose([Validators.required])],
      state: ["", Validators.compose([Validators.required])],
      country: ["", Validators.compose([Validators.required])],
      addressChecking: ["0"],
      checkAddressStreet: [""],
      checkAddressCountry: [""],
      checkAddressCity: [""],
      checkAddressState: [""],
      checkAddressZipCode: ["", Validators.compose([Validators.required])],
      contactFirstName: ["", Validators.compose([Validators.required])],
      contactCell: [
        "",
        Validators.compose([
          Validators.pattern(
            "^(1s?)?((([0-9]{3}))|[0-9]{3})[s-]?[\0-9]{3}[s-]?[0-9]{4}$"
          ),
        ]),
      ],
      contactEmailAddress: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(
            "[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{1,63}$"
          ),
        ]),
      ],
      zipCode: ["", Validators.compose([Validators.required])],
      contactLastName: ["", Validators.compose([Validators.required])],
      contactWorkPhone: [
        "",
        Validators.compose([
          Validators.pattern(
            "^(1s?)?((([0-9]{3}))|[0-9]{3})[s-]?[\0-9]{3}[s-]?[0-9]{4}$"
          ),
        ]),
      ],
    });
  }

  showSpinner() {
    this.spinner.show("mySpinner", {
      type: "line-scale-party",
      size: "large",
      bdColor: "rgba(100,149,237, .8)",
      color: "black",
    });
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
  }

  ngOnInit() {
    const sessionStart = localStorage.getItem("sessionStart");
    if (sessionStart) {
      const savedDate = Date.parse(sessionStart);
      let diffInMs = Math.abs(Date.now() - savedDate);
      setTimeout(() => {
        const companyName = localStorage.getItem("companyName");
        const contactName = localStorage.getItem("contactName");
        const email = localStorage.getItem("email");
        const phone = localStorage.getItem("phone");
        const logEntry: LogEntry = {
          pageNumber: 2,
          companyName: companyName,
          vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
          message:
            "Session time out - redirected to timeout page after 60 minutes",
          exception: null,
          clientId: "",
          clientSecret: "",
          email: email,
          phone: phone,
          contactName: contactName,
          sessionId: localStorage.getItem("sessionId"),
          password: null,
          companyLegalName: null,
          numberOfProperties: 0,
          numberOfUnits: 0,
          street1: null,
          city: null,
          state: null,
          zipCode: null,
          country: null,
          settlementAuth: null,
          clientVendorId: 1,
        };
        this.tokenLogService
          .logEntry(logEntry)
          .toPromise()
          .then(
            () => {
              console.log("Token entry set correctly");
            },
            (error) => {
              console.log(
                "An error has occurred while creating log entry: ",
                error
              );
            }
          );
        this.router.navigateByUrl("timeout");
      }, 60 * 60 * 1000 - diffInMs);
    }
    // logging second page
    const companyName = localStorage.getItem("companyName");
    const clientId = localStorage.getItem("clientId");
    const clientSecret = localStorage.getItem("clientSecret");
    const email = localStorage.getItem("email");
    const phone = localStorage.getItem("phone");
    const contactName = localStorage.getItem("contactName");
    const logEntry: LogEntry = {
      pageNumber: 2,
      companyName: companyName,
      vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
      message: "First registration page reached",
      exception: null,
      clientId: clientId,
      clientSecret: clientSecret,
      email: email,
      phone: phone,
      contactName: contactName,
      sessionId: localStorage.getItem("sessionId"),
      password: null,
      companyLegalName: null,
      numberOfProperties: 0,
      numberOfUnits: 0,
      street1: null,
      city: null,
      state: null,
      zipCode: null,
      country: null,
      settlementAuth: null,
      clientVendorId: 1,
    };
    this.tokenLogService
      .logEntry(logEntry)
      .toPromise()
      .then(
        () => {
          console.log("Token entry set correctly");
        },
        (error) => {
          console.log(
            "An error has occurred while creating log entry: ",
            error
          );
        }
      );

    this.allCountries = this.countryService.allCountryLists;
    this.registrationForm.controls["country"].setValue(
      this.allCountries[231]["code"]
    );
    this.registrationForm.controls["checkAddressCountry"].setValue(
      this.allCountries[231]["code"]
    );

    this.getFirstRegistrationFormVal = JSON.parse(
      localStorage.getItem("firstRegistrationDetails")
    );
    if (this.getFirstRegistrationFormVal) {
      this.registrationForm.controls["companyName"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["Name"]
      );
      this.registrationForm.controls["companyLegalName"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "LegalName"
        ]
      );
      this.registrationForm.controls["officeAddress"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["Street1"]
      );
      this.registrationForm.controls["country"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["country"]
      );
      this.registrationForm.controls["zipCode"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["ZipCode"]
      );
      this.registrationForm.controls["city"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["City"]
      );
      this.registrationForm.controls["state"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["State"]
      );
      this.countryName =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "Country"
        ];
      this.registrationForm.controls["checkAddressStreet"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressStreet1"
        ]
      );
      this.registrationForm.controls["checkAddressCountry"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressCountry"
        ]
      );
      this.registrationForm.controls["checkAddressCity"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressCity"
        ]
      );
      this.registrationForm.controls["checkAddressState"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressState"
        ]
      );
      this.registrationForm.controls["checkAddressZipCode"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressZipCode"
        ]
      );
      this.checkAddressCountryName =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressCountryName"
        ];
      this.registrationForm.controls["contactFirstName"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "FirstName"
        ]
      );
      this.registrationForm.controls["contactCell"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "CellPhone"
        ]
      );
      this.registrationForm.controls["contactEmailAddress"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["Email"]
      );
      this.registrationForm.controls["contactLastName"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "LastName"
        ]
      );
      this.registrationForm.controls["contactWorkPhone"].setValue(
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "WorkPhone"
        ]
      );
    }
  }

  get companyName() {
    return this.registrationForm.get("companyName");
  }
  get companyLegalName() {
    return this.registrationForm.get("companyLegalName");
  }
  get officeAddress() {
    return this.registrationForm.get("officeAddress");
  }
  get country() {
    return this.registrationForm.get("country");
  }
  get city() {
    return this.registrationForm.get("city");
  }
  get state() {
    return this.registrationForm.get("state");
  }
  get checkAddressCity() {
    return this.registrationForm.get("checkAddressCity");
  }
  get checkAddressCountry() {
    return this.registrationForm.get("checkAddressCountry");
  }
  get contactFirstName() {
    return this.registrationForm.get("contactFirstName");
  }
  get contactCell() {
    return this.registrationForm.get("contactCell");
  }
  get contactWorkPhone() {
    return this.registrationForm.get("contactWorkPhone");
  }
  get contactEmailAddress() {
    return this.registrationForm.get("contactEmailAddress");
  }
  get zipCode() {
    return this.registrationForm.get("zipCode");
  }
  get checkAddressZipCode() {
    return this.registrationForm.get("checkAddressZipCode");
  }
  get contactLastName() {
    return this.registrationForm.get("contactLastName");
  }

  clickRegistration() {
    if (this.registrationForm.controls.companyName.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.companyNameError = "Company name is required.";
    } else if (
      this.registrationForm.controls.companyLegalName.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.companyLegalNameError = "Company legal name is required.";
    } else if (
      this.registrationForm.controls.officeAddress.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.officeAddressError = "Street is required.";
    } else if (this.registrationForm.controls.country.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.countryError = "Country is required.";
    } else if (this.registrationForm.controls.zipCode.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.zipCodeError = "Zip code is required.";
    } else if (this.registrationForm.controls.city.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.cityError = "Physical address city is required.";
    } else if (this.registrationForm.controls.state.hasError("required")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.stateError = "Physical address state is required.";
    } else if (
      this.registrationForm.controls.contactFirstName.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactFirstNameError = "First name is required.";
    } else if (
      this.registrationForm.controls.contactLastName.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactLastNameError = "Last name is required.";
    } else if (
      this.registrationForm.controls.contactWorkPhone.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.workPhNoError = "Phone no is required.";
    } else if (
      this.registrationForm.controls.contactWorkPhone.hasError("pattern")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.workPhNoError = "Please enter a valid phone no.";
    } else if (this.registrationForm.controls.contactCell.hasError("pattern")) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactCellError = "Please enter a valid cell no.";
    } else if (
      this.registrationForm.controls.contactEmailAddress.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactEmailAddressError = "Email is required.";
    } else if (
      this.registrationForm.controls.contactEmailAddress.hasError("pattern")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.contactEmailAddressError = "Please enter a valid email.";
    } else {
      let firstRegistrationFormData = {};
      firstRegistrationFormData["Name"] =
        this.registrationForm.controls["companyName"].value;
      firstRegistrationFormData["LegalName"] =
        this.registrationForm.controls["companyLegalName"].value;
      firstRegistrationFormData["Street1"] =
        this.registrationForm.controls["officeAddress"].value;
      firstRegistrationFormData["City"] =
        this.registrationForm.controls["city"].value;
      firstRegistrationFormData["State"] =
        this.registrationForm.controls["state"].value;
      firstRegistrationFormData["Country"] = this.countryName;
      firstRegistrationFormData["ZipCode"] =
        this.registrationForm.controls["zipCode"].value;
      firstRegistrationFormData["checkAddressStreet1"] =
        this.registrationForm.controls["checkAddressStreet"].value;
      firstRegistrationFormData["checkAddressCity"] =
        this.registrationForm.controls["checkAddressCity"].value;
      firstRegistrationFormData["checkAddressState"] =
        this.registrationForm.controls["checkAddressState"].value;
      firstRegistrationFormData["checkAddressCountryName"] =
        this.registrationForm.controls["checkAddressCountry"].value;
      firstRegistrationFormData["checkAddressZipCode"] =
        this.registrationForm.controls["checkAddressZipCode"].value;
      firstRegistrationFormData["FirstName"] =
        this.registrationForm.controls["contactFirstName"].value;
      firstRegistrationFormData["LastName"] =
        this.registrationForm.controls["contactLastName"].value;
      firstRegistrationFormData["CellPhone"] =
        this.registrationForm.controls["contactCell"].value;
      firstRegistrationFormData["WorkPhone"] =
        this.registrationForm.controls["contactWorkPhone"].value;
      firstRegistrationFormData["Email"] =
        this.registrationForm.controls["contactEmailAddress"].value;
      localStorage.setItem(
        "companyName",
        this.registrationForm.controls["companyName"].value
      );
      localStorage.setItem(
        "email",
        this.registrationForm.controls["contactEmailAddress"].value
      );
      localStorage.setItem(
        "phone",
        this.registrationForm.controls["contactWorkPhone"].value
      );
      const contactName =
        this.registrationForm.controls["contactFirstName"].value +
        " " +
        this.registrationForm.controls["contactLastName"].value;
      localStorage.setItem("contactName", contactName);
      firstRegistrationFormData = { firstRegistrationFormData };
      if (firstRegistrationFormData) {
        localStorage.setItem(
          "firstRegistrationDetails",
          JSON.stringify(firstRegistrationFormData)
        );
        this.router.navigate(["/registration1"]);
      }
    }
  }

  changePhysicalAddressStateCity(selectedValue: any) {
    this.values = selectedValue.target.value;
    if (this.values != "") {
      this.stateName = "";
      this.cityName = "";
      this.noMatchStateCity = 0;
      if (!this.registrationForm.controls.zipCode.hasError("pattern")) {
        this.authService.getStateCity(this.values).subscribe(
          (stateCityval) => {
            if (stateCityval["results"].length > 0) {
              this.stateCityData =
                stateCityval["results"][0]["address_components"];
              if (
                typeof this.stateCityData != "undefined" &&
                typeof this.stateCityData &&
                this.stateCityData.length > 0
              ) {
                this.stateCityData.forEach((stateDataAllValue) => {
                  stateDataAllValue["types"].forEach((stateDataTypeValue) => {
                    if (stateDataTypeValue == "administrative_area_level_1") {
                      this.stateName = stateDataAllValue["short_name"];
                      this.registrationForm.controls["state"].setValue(
                        this.stateName
                      );
                    }
                    if (stateDataTypeValue == "locality") {
                      this.cityName = stateDataAllValue["long_name"];
                      this.registrationForm.controls["city"].setValue(
                        this.cityName
                      );
                    }
                    if (stateDataTypeValue == "country") {
                      this.countryName = stateDataAllValue["short_name"];
                      this.registrationForm.controls["country"].setValue(
                        stateDataAllValue["short_name"]
                      );
                      this.registrationForm.controls["country"].disable();
                    }
                  });
                });
              }
            } else {
              this.noMatchStateCity = 1;
              this.registrationForm.controls["state"].setValue("");
              this.registrationForm.controls["city"].setValue("");
              this.registrationForm.controls["country"].enable();
            }
          },
          (error) => (this.error = error)
        );
      } else {
        this.noMatchStateCity = 1;
        this.registrationForm.controls["state"].setValue("");
        this.registrationForm.controls["city"].setValue("");
        this.countryName = "";
      }
    } else {
      this.noMatchStateCity = 0;
      this.registrationForm.controls["state"].setValue("");
      this.registrationForm.controls["city"].setValue("");
    }
  }

  changeCheckAddressStateCity(selectedValue: any) {
    this.values = selectedValue.target.value;
    if (this.values != "") {
      if (selectedValue.target.value.length >= 5) {
        this.stateName = "";
        this.cityName = "";
        this.noMatchStateCityForCheckAddress = 0;
        if (
          !this.registrationForm.controls.checkAddressZipCode.hasError(
            "pattern"
          )
        ) {
          this.authService.getStateCity(this.values).subscribe(
            (stateCityval) => {
              if (stateCityval["results"].length > 0) {
                this.stateCityData =
                  stateCityval["results"][0]["address_components"];
                if (
                  typeof this.stateCityData != "undefined" &&
                  typeof this.stateCityData &&
                  this.stateCityData.length > 0
                ) {
                  this.stateCityData.forEach((stateDataAllValue) => {
                    stateDataAllValue["types"].forEach((stateDataTypeValue) => {
                      if (stateDataTypeValue == "administrative_area_level_1") {
                        this.stateName = stateDataAllValue["long_name"];
                        this.registrationForm.controls[
                          "checkAddressState"
                        ].setValue(this.stateName);
                      }
                      if (stateDataTypeValue == "locality") {
                        this.cityName = stateDataAllValue["long_name"];
                        this.registrationForm.controls[
                          "checkAddressCity"
                        ].setValue(this.cityName);
                      }
                      if (stateDataTypeValue == "country") {
                        this.checkAddressCountryName =
                          stateDataAllValue["long_name"];
                        this.registrationForm.controls[
                          "checkAddressCountry"
                        ].setValue(this.checkAddressCountryName);
                      }
                    });
                  });
                }
              } else {
                this.noMatchStateCityForCheckAddress = 1;
                this.registrationForm.controls["checkAddressState"].setValue(
                  ""
                );
                this.registrationForm.controls["checkAddressCity"].setValue("");
                this.countryName = "";
              }
            },
            (error) => (this.error = error)
          );
        } else {
          this.noMatchStateCityForCheckAddress = 1;
          this.registrationForm.controls["checkAddressState"].setValue("");
          this.registrationForm.controls["checkAddressCity"].setValue("");
        }
      } else {
        this.noMatchStateCityForCheckAddress = 0;
        this.registrationForm.controls["checkAddressState"].setValue("");
        this.registrationForm.controls["checkAddressCity"].setValue("");
      }
    } else {
      this.noMatchStateCityForCheckAddress = 0;
      this.registrationForm.controls["checkAddressState"].setValue("");
      this.registrationForm.controls["checkAddressCity"].setValue("");
    }
  }

  radioChange(event: any) {
    if (event.target.value == 1) {
      this.selectedCity = 1;
      this.registrationForm.controls["checkAddressStreet"].setValue(
        this.registrationForm.controls["officeAddress"].value
      );
      this.registrationForm.controls["checkAddressCity"].setValue(
        this.registrationForm.controls["city"].value
      );
      this.registrationForm.controls["checkAddressState"].setValue(
        this.registrationForm.controls["state"].value
      );
      this.registrationForm.controls["checkAddressZipCode"].setValue(
        this.registrationForm.controls["zipCode"].value
      );
      this.registrationForm.controls["checkAddressCountry"].setValue(
        this.registrationForm.controls["country"].value
      );
      this.registrationForm.controls["checkAddressStreet"].disable();
      this.registrationForm.controls["checkAddressCountry"].disable();
      this.registrationForm.get("checkAddressZipCode").disable();
      this.registrationForm.get("checkAddressCity").disable();
      this.registrationForm.get("checkAddressState").disable();
    } else {
      this.selectedCity = 0;
      this.registrationForm.controls["checkAddressStreet"].setValue("");
      this.registrationForm.controls["checkAddressCity"].setValue("");
      this.registrationForm.controls["checkAddressState"].setValue("");
      this.registrationForm.controls["checkAddressZipCode"].setValue("");
      this.registrationForm.controls["checkAddressCountry"].setValue("US");
      this.registrationForm.controls["checkAddressStreet"].enable();
      this.registrationForm.controls["checkAddressCountry"].enable();
      this.registrationForm.get("checkAddressCity").enable();
      this.registrationForm.get("checkAddressState").enable();
      this.registrationForm.get("checkAddressZipCode").enable();
    }
  }
}
